// src/pages/Profile/AccountInformation.jsx
import React from 'react';
import {
    Box,
    Typography,
    Button,
    Divider,
    Grid,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const AccountInformation = ({
    isArabic,
    user,
    createdAtFormatted,
    onEdit,
}) => {
    const { email, phone, user_name } = user;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: 2,
                    mb: 2,
                }}
            >
                <Box>
                    <Typography variant="h6" fontWeight={600}>
                        {isArabic ? 'بيانات الحساب' : 'Account details'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {isArabic
                            ? 'معلومات الاتصال وبيانات الحساب الخاصة بك.'
                            : 'Your contact and account information.'}
                    </Typography>
                </Box>

                <Button
                    onClick={onEdit}
                    variant="outlined"
                    startIcon={<EditIcon />}
                    size="small"
                >
                    {isArabic ? 'تعديل الملف' : 'Edit profile'}
                </Button>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FieldBlock
                        label={isArabic ? 'البريد الإلكتروني' : 'Email'}
                        value={email}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FieldBlock
                        label={isArabic ? 'رقم الجوال' : 'Phone'}
                        value={phone || '-'}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FieldBlock
                        label={isArabic ? 'تاريخ الإنشاء' : 'Created at'}
                        value={createdAtFormatted}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FieldBlock
                        label={isArabic ? 'اسم المستخدم' : 'Username'}
                        value={user_name}
                    />
                </Grid>
            </Grid>
        </>
    );
};

const FieldBlock = ({ label, value }) => (
    <>
        <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textTransform: 'uppercase' }}
        >
            {label}
        </Typography>
        <Typography variant="body1">{value}</Typography>
    </>
);

export default AccountInformation;
